import React, { useEffect, useState } from 'react';

import {

  Typography,

  Box,

  Button,

  IconButton,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  Alert,

  Stack,

  TextField,

  Grid

} from '@mui/material';

import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import InfoRoundedIcon from '@mui/icons-material/InfoOutlined';

import { useAuth } from '../../contexts/AuthContext';

import api from '../../services/api';

import { useNavigate } from 'react-router-dom';

import ImplementacionGuiaImg from '../../assets/card-services.png'; // Asegúrate de que la ruta es correcta

import { useTranslation } from 'react-i18next';

import { useContext } from 'react';

import { AWSContext } from '../../contexts/AWSContext';

import PlataformaSelector from '../../components/guias/PlataformaSelector';

import GeometryImage from '../../assets/left-image-widget.png';
import ActiveCampaignForm from '../../components/ActiveCampaignForm';



const Widget = () => {

  const { user } = useAuth();

  const navigate = useNavigate();

  const [widgets, setWidgets] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const [selectedWidget, setSelectedWidget] = useState(null);



  // Estado para el Modal de Contratar Widget

  const [modalOpen, setModalOpen] = useState(false);

  const { isAWS } = useContext(AWSContext);

  const [assignDomainModalOpen, setAssignDomainModalOpen] = useState(false);

  const [selectedWidgetForDomain, setSelectedWidgetForDomain] = useState(null);

  const [domainToAssign, setDomainToAssign] = useState('');

  const [assignDomainError, setAssignDomainError] = useState('');



  const { t } = useTranslation(); // Extraemos solo 't'



  const [favicons, setFavicons] = useState({});



  useEffect(() => {

    const genericUrl = 'https://www.google.com/s2/favicons?domain=example.com&sz=64';

    const genericImg = new Image();

    genericImg.src = genericUrl;



    genericImg.onload = () => {

      const updatedFavicons = {};

      const promises = widgets.map((widget) => {

        return new Promise((resolve) => {

          if (!widget.dominio) {

            updatedFavicons[widget.id] = GeometryImage;

            return resolve();

          }



          const widgetFavicon = new Image();

          const url = `https://www.google.com/s2/favicons?domain=${widget.dominio}&sz=64`;

          widgetFavicon.src = url;



          widgetFavicon.onload = () => {

            if (

              widgetFavicon.naturalWidth === genericImg.naturalWidth &&

              widgetFavicon.naturalHeight === genericImg.naturalHeight

            ) {

              updatedFavicons[widget.id] = GeometryImage;

            } else {

              updatedFavicons[widget.id] = url;

            }

            resolve();

          };



          widgetFavicon.onerror = () => {

            updatedFavicons[widget.id] = GeometryImage;

            resolve();

          };

        });

      });



      Promise.all(promises).then(() => {

        setFavicons(updatedFavicons);

      });

    };

  }, [widgets]);



  useEffect(() => {

    window.scrollTo(0, 0);

  }, []);



  useEffect(() => {

    const fetchCustomerDetails = async () => {

      try {

        await api.get(`/customer-details?user_id=${user.id}`);

        // Eliminar referencias a billing_cycle

      } catch (err) {

        setError(t('widget.errorCustomerDetails') || 'No se pudieron obtener los detalles del cliente.');

      }

    };



    if (user && user.id) {

      fetchCustomerDetails();

    }

  }, [user, t]);



  useEffect(() => {

    const fetchWidgets = async () => {

      try {

        const response = await api.get(`/servicios?user_id=${user.id}`);

        setWidgets(response.data);

      } catch (error) {

        setError(t('widget.errorFetchingWidgets') || 'Error al obtener widgets.');

      } finally {

        setLoading(false);

      }

    };



    if (user && user.id) {

      fetchWidgets();

    }

  }, [user, t]);



  const handleModify = (widget) => {

    if (isAWS) {

      navigate('/dashboard/modify-plan-aws', {

        state: {

          service_id: widget.id,

          billing_interval_type: widget.billing_cycle_type

        }

      });

    } else {

      navigate('/dashboard/home');

    }

  };





  const handleCancel = (widget) => {

    if (isAWS) {

      // Redirigir al AWS Marketplace para cancelar la suscripción

      const awsMarketplaceUrl = process.env.AWS_MARKETPLACE_CANCEL_URL || 'https://aws.amazon.com/marketplace/pp/prodview-3yziwygxgj6do';

      window.open(awsMarketplaceUrl, '_blank');

    } else {

      setSelectedWidget(widget);

      setCancelDialogOpen(true);

    }

  };



  const confirmCancel = async () => {

    if (!selectedWidget || !selectedWidget.id) {

      setError(t('widget.errorCancelSubscription') || 'No se pudo obtener el subscription_id del widget seleccionado.');

      return;

    }

    try {

      await api.delete('/cancel-subscription', {

        data: { service_id: selectedWidget.id },

      });

      setCancelDialogOpen(false);

      // Actualizar la lista de widgets o recargar

      window.location.reload();

    } catch (error) {

      setError(t('widget.errorCancelSubscription') || 'Error al cancelar suscripción.');

    }

  };



  // Funciones para manejar el Modal de Contratar Widget

  const handleOpenModal = () => {

    setModalOpen(true);

  };



  const handleCloseModal = () => {

    setModalOpen(false);

  };



  const handleOpenAssignDomainModal = (widget) => {

    setSelectedWidgetForDomain(widget);

    setAssignDomainModalOpen(true);

  };



  const handleCloseAssignDomainModal = () => {

    setAssignDomainModalOpen(false);

    setDomainToAssign('');

    setAssignDomainError('');

    setSelectedWidgetForDomain(null);

  };



  const handleAssignDomainSubmit = async () => {

    setAssignDomainError('');

    try {

      // Realiza la llamada a tu servidor para asignar el dominio al widget (o servicio)

      await api.post('/assign-domain', {

        service_id: selectedWidgetForDomain.id,

        domain: domainToAssign.trim(),

      });

      // Si la asignación fue exitosa, recarga la lista o actualiza el estado

      window.location.reload();

    } catch (error) {

      setAssignDomainError(t('widget.assignDomainError') || 'Error al asignar dominio.');

    }

  };





  return (

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Cabecera fija */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            width: "100%",

          }}

        >

          <Box sx={{ 

            display: { xs: "flex", sm: "flex" }, 

            flexDirection: "row", 

            alignItems: "center",

            flex: 1,

            ml: { xs: 35.5, md: 35.5 },

          }}>

            <Typography

              variant="h5"

              sx={{

                fontSize: { xs: "18px", sm: "16px", md: "14px", lg: "20px" },

                fontWeight: "medium",

                color: "#000",

              }}

            >

              {t('widget.title')}

            </Typography>

          </Box>



          <Box

            sx={{

              display: "flex",

              gap: { xs: 1.5, sm: 2 },

              mr: { xs: 1.5, md: 5 },

              alignItems: "center",

            }}

          >

          </Box>

        </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      <Box

        sx={{

          ml: { xs: -6, md: 0 },

          paddingLeft: { xs: 6, md: 2 },

          paddingRight: { xs: 0, md: 4 },

        }}

      >

    <Box sx={{ pb: 0, pt: { xs: 0, md: 2 }, mb: { xs: 0, md: -5 } }}>



      {/* Mensaje Informativo */}

      <Box

        sx={{

          display: 'flex',

          alignItems: 'center',

          mb: { xs: 7, md: 10 },

          backgroundColor: '#E6F0FF',

          borderRadius: 2,

          paddingTop: '5px',

          paddingBottom: '5px',

        }}

      >

        <InfoRoundedIcon sx={{ color: '#1976d2', mr: 1, ml: 1 }} />

        <Typography variant="body1" sx={{ color: '#0F52BD' }}>

          {t('widget.infoMessage')}

        </Typography>

      </Box>





      {/* Sección "Guía de Implementación" */}

      <Box sx={{ mb: 6 }}>

        <Typography

          variant="h5"

          gutterBottom

          sx={{ fontSize: '34px', fontWeight: 'medium', color: '#000' }}

        >

          {t('widget.implementationGuideTitle')}

        </Typography>

        <Box

          sx={{

            display: 'flex',

            alignItems: 'center',

            justifyContent: 'flex-start',

            gap: 2,

            flexWrap: 'wrap', // Permite que los elementos se ajusten en pantallas más pequeñas

          }}

        >

          {/* Imagen */}

          <Box

            component="img"

            src={ImplementacionGuiaImg}

            alt={t('widget.implementationGuideAlt') || 'Guía de Implementación'}

            sx={{

              width: { xs: '100%', sm: '376px' }, // Responsivo

              height: 'auto',

              borderRadius: 2,

              boxShadow: '0px 4px 10px 0px rgba(98, 113, 137, 0.46)',

              flexShrink: 0,

            }}

          />



          {/* Descripción y Botón */}

          <Box

            sx={{

              display: 'flex',

              flexDirection: 'column',

              justifyContent: 'space-between',

              gap: { xs: 2, md: 11 },

              ml: { xs: 0, md: 2 },

              width: { xs: '100%', sm: '50%' }, // Responsivo

              maxWidth: { sm: '600px' },

            }}

          >

            <Box

              sx={{

                display: 'flex',

                alignItems: 'center',

                borderLeft: '1px solid #0F52BD',

                pl: 2,

              }}

            >

              <Typography variant="body1" gutterBottom sx={{ color: '#595959' }}>

                {t('widget.implementationGuideDescription')}

              </Typography>

            </Box>

          </Box>

        </Box>

      </Box>



      {/* Lista de guías */}

      <PlataformaSelector />



      {/* Sección "Dominios contratados" */}

      <Grid container spacing={2} sx={{ mt: { xs: 7, md: 10 }, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>

        <Grid item>

          <Typography variant="h5" sx={{ fontSize: '34px', fontWeight: 'medium', color: '#000' }}>

            {t('widget.contractedDomainsTitle')}

          </Typography>

        </Grid>

        <Grid item>

          {!isAWS && (

            <Button

              variant="contained"

              color="primary"

              onClick={handleOpenModal}

              sx={{

                alignSelf: 'flex-start',

                paddingTop: '10px',

                paddingBottom: '10px',

                paddingRight: '30px',

                paddingLeft: '30px',

                textTransform: 'none',

                fontSize: '18px',

                borderRadius: '7px',

                marginLeft: { xs: 0, md: '39px' },

              }}

            >

              {t('widget.addButton')}

            </Button>

          )}

        </Grid>

      </Grid>



      {/* Listado de Widgets Contratados */}

      {error && <Alert severity="error" sx={{ mb: 2, mt: 2 }}>{error}</Alert>}



      {

        loading ? (

          <Typography>{t('widget.loadingWidgets')}</Typography>

        ) : widgets.length > 0 ? (

          <Stack spacing={2} divider={<Box sx={{ width: '100%', height: '1px', bgcolor: '#0F52BD' }} />}>

            {widgets.map((widget) => (



              <Box

                key={widget.id}

                sx={{

                  display: 'flex',

                  alignItems: 'center',

                  justifyContent: 'space-between',

                  py: 2,

                  flexWrap: 'wrap',

                }}

              >

                {/* Imagen a la Izquierda */}

                <Box

                  component="img"

                  src={favicons[widget.id] || `https://www.google.com/s2/favicons?domain=${widget.dominio}&sz=64`}

                  alt={widget.nombre}

                  sx={{

                    width: { xs: '50px', md: '70px' },

                    height: { xs: '50px', md: '70px' },

                    borderRadius: '8px',

                    mr: 2,

                  }}

                />



                {/* Detalles del Widget */}

                <Grid item sx={{ flex: 1, minWidth: '200px' }}>

                  <Typography variant="h6">{widget.nombre}</Typography>

                  <Typography variant="body2">

                    {t('widget.contractedDomain')}:{" "}

                    {widget.dominio ? (

                      widget.dominio

                    ) : (

                      isAWS && (

                        <Button

                          variant="outlined"

                          size="small"

                          onClick={() => handleOpenAssignDomainModal(widget)}

                          sx={{ textTransform: 'none', fontSize: '12px' }}

                        >

                          {t('widget.assignDomainButton')}

                        </Button>

                      )

                    )}

                  </Typography>

                  <Typography variant="body2">

                    {t('widget.contractDate')}: {new Date(widget.fecha_contratacion).toLocaleDateString()}

                  </Typography>

                </Grid>



                {/* Botones */}

                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                  {/* Botón de Estadísticas */}

                  <Button

                    variant="outlined"

                    color="primary"

                    onClick={() => navigate(`/dashboard/widgets/${widget.dominio}/estadisticas`)}

                    sx={{

                      textTransform: 'none',

                      borderColor: '#0F52BD',

                      borderRadius: '10px',

                      paddingLeft: '37px',

                      paddingRight: '37px',

                      marginRight: '17px',

                      color: '#0F52BD',

                      '&:hover': {

                        backgroundColor: '#0F52BD',

                        color: '#fff',

                      },

                    }}

                  >

                    {t('widget.statisticsButton')}

                  </Button>



                  {/* Botón de Editar */}

                  <IconButton

                    onClick={() => handleModify(widget)}

                    sx={{

                      color: '#999',

                      '&:hover': {

                        color: '#0F52BD',

                      },

                    }}

                  >

                    <DriveFileRenameOutlineIcon />

                  </IconButton>



                  {/* Botón de Eliminar */}

                  <IconButton

                    onClick={() => handleCancel(widget)}

                    sx={{

                      color: '#999',

                      '&:hover': {

                        color: '#FF0000',

                      },

                    }}

                  >

                    <DeleteOutlineIcon />

                  </IconButton>

                </Grid>

              </Box>

            ))}

          </Stack>

        ) : (

          <Typography sx={{ mt: 3 }}>{t('widget.noWidgets')}</Typography>

        )

      }



      {/* Dialog para cancelar suscripción */}

      <Dialog open={cancelDialogOpen} onClose={() => setCancelDialogOpen(false)}>

        <DialogTitle>{t('widget.cancelSubscriptionTitle')}</DialogTitle>

        <DialogContent>

          <Typography>{t('widget.cancelSubscriptionMessage')}</Typography>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setCancelDialogOpen(false)}>{t('widget.cancelButton')}</Button>

          <Button onClick={confirmCancel} variant="contained" color="secondary">

            {t('widget.confirmCancelButton')}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Modal para Contratar Widget */}

      <Dialog open={modalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">

        <DialogTitle sx={{ fontWeight: 'medium', fontSize: '24px' }}>Contratar Widget</DialogTitle>

        <DialogContent sx={{ padding: '25px' }}>

          <ActiveCampaignForm open={modalOpen} />

        </DialogContent>

        <DialogActions sx={{ paddingRight: '25px', paddingBottom: '25px' }}>

          <Button onClick={handleCloseModal} variant="contained" sx={{ textTransform: 'none', fontSize: '16px' }}>
            Cerrar
          </Button>

        </DialogActions>

      </Dialog>



      <Dialog open={assignDomainModalOpen} onClose={handleCloseAssignDomainModal} fullWidth maxWidth="sm">

        <DialogTitle sx={{ fontWeight: 'medium', fontSize: '24px' }}>

          {t('widget.assignDomainModalTitle')}

        </DialogTitle>

        <DialogContent>

          {assignDomainError && <Alert severity="error" sx={{ mb: 2 }}>{assignDomainError}</Alert>}

          <TextField

            fullWidth

            label={t('widget.domainInputLabel')}

            placeholder={t('widget.domainInputPlaceholder')}

            value={domainToAssign}

            onChange={(e) => setDomainToAssign(e.target.value)}

            sx={{ backgroundColor: '#F1F1F1' }}

            margin="dense"

          />

        </DialogContent>

        <DialogActions sx={{ paddingRight: '25px', paddingBottom: '25px' }}>

          <Button onClick={handleCloseAssignDomainModal} sx={{ textTransform: 'none', fontSize: '16px' }}>

            {t('widget.cancelButton')}

          </Button>

          <Button

            onClick={handleAssignDomainSubmit}

            variant="contained"

            color="primary"

            sx={{ textTransform: 'none', fontSize: '16px' }}

          >

            {t('widget.assignDomainButton')}

          </Button>

        </DialogActions>

      </Dialog>



    </Box>

      </Box>

    </Box>

  );



};



export default Widget;
